/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/
import './../styles/style.scss';
console.log('fdsfdsfdsfs')

/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import $ from 'cash-dom';
import Choices from 'choices.js';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';

document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) e.target.style.backgroundImage = 'url(' + bg + ')';
});



$(() => {

    //Only allow future dates to be in put in the date input
    $('.js-future-only').each((index, element) => {
        $(element).attr('min', new Date().toISOString().split('T')[0]);
    });

    /**
     * If there is a query in the url then we shoul scroll to it
     */
    if (window.location.hash && window.location.hash.indexOf(`#q|`) > -1) {

        // Convert from base64 to a string
        let query = atob(window.location.hash.replace(`#q|`, ``));

        // Limit the search to the blur div
        let blur = document.querySelector('.blur');

        // Find the element with the query
        const elements = Array.from(blur.querySelectorAll('p,h1,h2,h3,h4,h5,h6'));

        // Find the matching element
        const match = elements.find(el => el.textContent.toLowerCase().includes(query.toLowerCase()));

        console.log(match)

        // Scroll to matching element
        if (match) {
            const rect = match.getBoundingClientRect();
            const top = rect.top + window.pageYOffset - 140;
            window.scrollTo({ top, behavior: 'smooth' });

            match.style.background = '#f05a28'
            match.style.color = '#fff'

            match.classList.add('highlighted-search')

        }
    }

    if ($('.comments-holder-container').length) {
        if (window.location.hash && window.location.hash.indexOf(`#CommentForm`) > -1) {
            // scroll to the hash div on page load using vanilla js
            setTimeout(() => {
                document.querySelector(window.location.hash).parentNode.parentNode.parentNode.scrollIntoView({ behavior: "smooth" });
                // Add the class to highlight the comment
                $(window.location.hash).parent().parent().find('.comment-reply-form-holder').show();
            }, 500);

        }
    }

    let url = new URL(window.location.href);
    let scid = url.searchParams.get('scid');


    /**
     * If a user clicks on a link inside of a block
     */
    $('body').on('click', '.tabBlock__wrap__content a, .textBlock a, .heroBlock__wrap__content a,.banner__wrap__item__content__inner__box a', (e) => {
        let $this = $(e.currentTarget);
        let url = new URL(window.location.href);
        let scid = url.searchParams.get('scid');


        if ($this.attr('href').includes('drive.spaceshipsrentals') && scid) {
            e.preventDefault();

            if ($this.attr('href').includes('?')) {
                window.location = $this.attr('href') + `&scid=${scid}`;
            } else {
                window.location = $this.attr('href') + `?scid=${scid}`;
            }
        }

    });



    $('.quote__wrap__pickup__location select,.quote__wrap__dropoff__location select').each((index, element) => {
        const choices = new Choices(element, {
            searchEnabled: true,
            placeholderValue: "Please select a country",
            itemSelectText: '',
            searchEnabled: false
        });
    });




    function getVerticalScrollPercentage(elm) {
        var p = elm.parentNode
        return (elm.scrollTop || p.scrollTop) / (p.scrollHeight - p.clientHeight) * 100
    }

    if ($('.progress-bar').length) {
        document.onscroll = function () {
            var pos = getVerticalScrollPercentage(document.body);
            $('.progress-bar').css({ width: `${Math.round(pos)}%` });
        }
    }

});



/*------------------------------------------------------------------
Helpers
------------------------------------------------------------------*/

const query = document.querySelector.bind(document);
const queryAll = document.querySelectorAll.bind(document);

/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

import './components/imageText';
import './components/inview';
import './components/mobileMenu';
import './components/search';
import './components/grid';
import './components/banner';
import './components/videoModal';
import './components/accordionBlock';
import './components/tabbed';
import './components/gallerySlider';


/*------------------------------------------------------------------
Components
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {

    /*------------------------------------------------------------------
    Update placeholder
    ------------------------------------------------------------------*/

    query('#CustomSearchForm_SearchForm_Search').placeholder = 'What are you looking for?';

    /*------------------------------------------------------------------
    Sticky header  
    ------------------------------------------------------------------*/

    let previousScrollPosition = 0;
    let scrollDelta = 5;
    let header = query('.header');
    let headerHeight = (header) ? header.clientHeight / 3 : 0;

    const stickyHeader = () => {
        let st = window.scrollY;
        if (Math.abs(previousScrollPosition - st) <= scrollDelta) return;
        if (st === 0) {
            header.classList.remove('nav-down');
            header.classList.remove('nav-up');
        } else if (st > previousScrollPosition && st > headerHeight) {
            header.classList.remove('nav-down');
            header.classList.add('nav-up');
        } else {
            if (st + window.innerHeight < document.body.clientHeight) {
                header.classList.add('nav-down');
                header.classList.remove('nav-up');
            }
        }
        previousScrollPosition = st;
    }

    window.addEventListener('scroll', stickyHeader);

    [...queryAll('.js-postload')].forEach(item => {
        item.classList.remove('js-postload');
    });

});


/*------------------------------------------------------------------
Calendar
------------------------------------------------------------------*/
import dayjs from 'dayjs';

import Calendar from './components/calendar'

$(() => {

    let $body = $('body');


    $body.on('click', ' .get_a_quote', (e) => {
        e.preventDefault();

        let base = '';

        switch (true) {
            case window.location.href.indexOf('co.uk') > -1:
                base = 'https://drive.spaceshipsrentals.co.uk/';
                break;
            case window.location.href.indexOf('co.nz') > -1:
                base = 'https://drive.spaceshipsrentals.co.nz/';
                break;
            default:
                base = 'https://drive.spaceshipsrentals.com.au/';
                break;
        }

        let url = new URL(window.location.href);
        let scid = url.searchParams.get('scid');

        if (scid) {
            window.location = `${base}?scid=${scid}`;
        } else {
            window.location = `${base}`;
        }
    });

    $body.on('click', '.js-go-to-book', (e) => {
        e.preventDefault();

        let base = '';

        switch (true) {
            case window.location.href.indexOf('co.uk') > -1:
                base = 'https://drive.spaceshipsrentals.co.uk/';
                break;
            case window.location.href.indexOf('co.nz') > -1:
                base = 'https://drive.spaceshipsrentals.co.nz/';
                break;
            default:
                base = 'https://drive.spaceshipsrentals.com.au/';
                break;
        }

        let url = new URL(window.location.href);
        let scid = url.searchParams.get('scid');

        if (scid) {
            window.location = `${base}?scid=${scid}`;
        } else {
            window.location = `${base}`;
        }
    });

    let defaults = $('.js-defaults')[0];
    const getDefaultPickupDate = (daysFromNow = 10) => {
        let url = new URL(window.location.href);
        let pickupDate = url.searchParams.get('pickup-date');
        if (pickupDate) {
            return new dayjs(pickupDate, 'DD MMMM YYYY').startOf('day');
        } else {
            if (defaults.hasAttribute('data-pickup-date')) daysFromNow = parseInt(defaults.getAttribute('data-pickup-date'));
            return new dayjs().startOf('day').add(daysFromNow, 'days');
        }
    };

    const getDefaultDropoffDate = (daysFromNow = 20) => {
        let url = new URL(window.location.href);
        let dropoffDate = url.searchParams.get('dropoff-date');
        if (dropoffDate) {
            return new dayjs(dropoffDate, 'DD MMMM YYYY').startOf('day');
        } else {
            if (defaults.hasAttribute('data-dropoff-date')) daysFromNow = parseInt(defaults.getAttribute('data-dropoff-date'));
            return new dayjs().startOf('day').add(daysFromNow, 'days');
        }
    };



    $body.on('click', '.js-pickup', (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        $('.js-pickup').removeClass('selected');
        $this.addClass('selected');
    });

    $body.on('click', '.js-dropoff', (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        $('.js-dropoff').removeClass('selected');
        $this.addClass('selected');
    });


    if ($('.js-pickup-time-hitbox').length) {

        let _calendar = new Calendar($('.js-pickup-time'), $('.js-dropoff-time'), $('.js-calendar'), new dayjs(getDefaultPickupDate()), new dayjs(getDefaultDropoffDate()));

        _calendar.render();

        $('.js-pickup-time-hitbox').on('click', () => {
            _calendar.move('pickup');
            _calendar.show();
        });

        $('.js-dropoff-time-hitbox').on('click', () => {
            if (_calendar.dropoffDate) {
                _calendar.move('dropoff');
                _calendar.show();
            } else {
                _calendar.move('pickup');
                _calendar.show();
            }
        });

        $body.on('click', '.js-book', (e) => {
            e.preventDefault();
            let $quote = $(e.currentTarget).closest('.quote');
            let pickupLocation = $quote.find('.js-pickup.selected').attr('data-id');
            let pickupTime = new dayjs($quote.find('.js-pickup-time').val(), 'D MMMM YYYY').format('DD+MMMM+YYYY');
            let dropoffLocation = $quote.find('.js-dropoff.selected').attr('data-id');
            let dropoffTime = new dayjs($quote.find('.js-dropoff-time').val(), 'D MMMM YYYY').format('DD+MMMM+YYYY');

            if ($('.js-pickup-select').length) pickupLocation = $('.js-pickup-select').val();
            if ($('.js-dropoff-select').length) dropoffLocation = $('.js-dropoff-select').val();

            let base = '';

            switch (true) {
                case window.location.href.indexOf('co.uk') > -1:
                    base = 'https://drive.spaceshipsrentals.co.uk/';
                    break;
                case window.location.href.indexOf('co.nz') > -1:
                    base = 'https://drive.spaceshipsrentals.co.nz/';
                    break;
                default:
                    base = 'https://drive.spaceshipsrentals.com.au/';
                    break;
            }

            let url = new URL(window.location.href);
            let scid = url.searchParams.get('scid');

            if (scid) {
                window.location = `${base}?pickup-date=${pickupTime}&dropoff-date=${dropoffTime}&pickup-location=${pickupLocation}&dropoff-location=${dropoffLocation}&pickup-time=10:00+am&dropoff-time=15:00+pm&scid=${scid}`;
            } else {
                window.location = `${base}?pickup-date=${pickupTime}&dropoff-date=${dropoffTime}&pickup-location=${pickupLocation}&dropoff-location=${dropoffLocation}&pickup-time=10:00+am&dropoff-time=15:00+pm`;

            }

        });

    }


    let expanded = false;

    $body.on('click', '.js-expand-all-specifiactions', (e) => {
        e.preventDefault();
        if (expanded) {
            $('.expandable').css({ maxHeight: '20rem' });
            $('.js-expand-text').text('View all Specifications & Features');
            $('.js-expand-all-specifiactions svg').css({ transform: 'rotate(0deg)' });
            expanded = false;
        } else {
            $('.expandable').css({ maxHeight: '100rem' });
            $('.js-expand-text').text('Show less Specifications & Features');
            $('.js-expand-all-specifiactions svg').css({ transform: 'rotate(180deg)' });
            expanded = true;
        }
    });


    $body.on('click', '.js-scroll-to-quote', (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        $('html, body').animate({
            scrollTop: $('.quote').offset().top - $('.header').height() - 40
        }, 'slow');
    });

    $body.on('click', '.js-scroll-to-compare', (e) => {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('.comparison').offset().top - $('.header').height() - 140
        }, 'slow');
    });


    // Wrap all video iframes inside of a div with a class of embed-container
    $('.textBlock__wrap iframe').each(function () {
        if ($(this).attr('src').indexOf('youtube') > -1) {
            $(this).wrap("<div class='embed-container'></div>");
        }
    });

});
